import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';

import SsoProvisioningSettings from '@/modules/sso-provisioning/views/SsoProvisioningSettings.vue';

export const ssoProvisioningModule = createModuleBuilder()
    .registerRoutes(() => [
        {
            path: '/:rpId?/configuration/sso',
            name: 'sso',
            component: SsoProvisioningSettings as any,
            meta: { title: 'Single sign-on', pageClass: 'SsoProvisioningSettings' },
        },
    ])
    .demandContext<{ gatewayClient: GatewayApiClient }>()
    .end();
